export const SPACER_IMAGE_URL = 'https://res.cloudinary.com/ddsqycvoq/image/upload/w_600,f_auto/web/glimmer-dashboard-spacer.jpg';
export const DASHBOARD_MAX_ANIMATION_DURATION_MS = 6000;

export const DASHBOARD_TYPES = {
  BUYER: 'BUYER',
  SELLER: 'SELLER',
};
